module.exports = __webpack_public_path__ + "img/205.e6874016.jpg";